import { Injectable } from "@angular/core";
import { ID } from "@common/interfaces/id";
import { IID_OL_ANNULLAMENTO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, StoreConfig, EntityStore } from "@datorama/akita";

export interface IIDolAnnullatoState extends EntityState<IID_OL_ANNULLAMENTO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_ANNULLATO })
export class IIDolAnnullatoStore extends EntityStore<IIDolAnnullatoState> {
  constructor() {
    super([]);
  }
}
